module.exports = __webpack_public_path__ + "media/volvo/assets/images/phones@2x-ecec6a1bf764bdfbd95771ebbcb79444.png";